import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import { createUseStyles, Button, useTheme } from '@Sage/hoi-poi-ui';
import ContentLoader from 'react-content-loader';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'ContractsValidation');

const ContractsValidation = memo(({ contracts, sendAcceptance, logOut, completeLogin }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();
    const theme = useTheme();
    const [finalContract, setFinalContract] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const finalContracts = useRef([]);

    const onConfirm = useCallback(() => {
        setIsLoading(true);
        sendAcceptance &&
            sendAcceptance({ idAgreement: finalContract?.id, accepted: true })
                .then(() => {
                    finalContracts.current?.shift();
                    if (finalContracts.current?.length) {
                        setFinalContract(finalContracts.current[0]);
                        setIsLoading(false);
                    } else {
                        return completeLogin();
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.error(err);
                });
    }, [finalContract?.id, sendAcceptance, completeLogin]);

    const onCancel = useCallback(() => {
        if (finalContract?.needAccept) return logOut && logOut();
        else {
            finalContracts.current?.shift();
            sendAcceptance &&
                sendAcceptance({
                    idAgreement: finalContract?.id,
                    accepted: false,
                });

            if (finalContracts.current?.length) {
                setFinalContract(finalContracts.current[0]);
                setIsLoading(false);
            } else {
                return completeLogin();
            }
        }
    }, [finalContract?.id, finalContract?.needAccept, logOut, sendAcceptance, completeLogin]);

    useEffect(() => {
        if (contracts?.length && !finalContracts.current.length) {
            finalContracts.current = contracts;
            setFinalContract(contracts[0]);
            setIsLoading(false);
        }
    }, [contracts, finalContract, setFinalContract]);

    return (
        <div className={classes.iframeContainer}>
            {(!contracts || isLoading) && (
                <ContentLoader
                    height={900}
                    width={900}
                    speed={2}
                    backgroundColor={theme.colors.grey[50]}
                    foregroundColor={theme.colors.grey[100]}
                >
                    <rect x="0" y="40" rx="3" ry="3" width={200} height="8" />
                    <rect x="0" y="70" rx="3" ry="3" width={120} height="8" />
                    <rect x="0" y="120" rx="3" ry="3" width={900} height="900" />
                </ContentLoader>
            )}
            {finalContract?.agreementUrl && !isLoading && (
                <iframe
                    className={classes.iframe}
                    title="contract"
                    src={finalContract?.agreementUrl}
                />
            )}
            <div className={classes.buttonsContainer}>
                <Button onClick={onCancel} className={classes.button} type="terciary">
                    {t('action_cancel')}
                </Button>
                <Button onClick={onConfirm} isLoading={isLoading}>
                    {t('action_accept')}
                </Button>
            </div>
        </div>
    );
});

export default ContractsValidation;
